import React from 'react';

export default ({ color }) => (
  <strong>
    <i
      className="now-ui-icons ui-1_simple-remove"
      style={{ color: color || 'red' }}
    />
  </strong>
);
